import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import endpointList from '../../config/endpointList.jsx'


export const fetchUserById = createAsyncThunk(
  'user/fetchById',
  async (userId, thunkAPI) => {
    try {
      const url = `${endpointList.getUsers}?user_id=${encodeURIComponent(userId)}`
      console.log(' Fetching user with URL:', url)

      const response = await axios.get(url)
      console.log(' raw response:', response.data)
      return response.data
    } catch (error) {
 
      const payload = error.response
        ? { status: error.response.status, data: error.response.data }
        : { message: error.message }

      return thunkAPI.rejectWithValue(payload)
    }
  }
)

const userSlice = createSlice({
  name: 'user',
  initialState: {
    data: null,
    status: 'idle',
    error: null,
  },
  reducers: {
    // if you want to explicitly set guest, you could add:
    setGuest(state) {
      state.data = { user_id: null, user_role: 'guest' }
      state.status = 'succeeded'
      state.error = null
    }
    },
  extraReducers: builder => {
    builder
      .addCase(fetchUserById.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(fetchUserById.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
      })
      .addCase(fetchUserById.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload
      })
  },
})

export const { setGuest } = userSlice.actions
export default userSlice.reducer
